@defer (when tileName) {
  <div class="tile" [class.active]="active">
    <div class="title">{{ tileName }}</div>
    <div class="data">
      @switch (tileName) {
        @case ('setpoints') {
          <app-dashboard-tile-data-setpoints [recent]="recent" />
        }
        @case ('telemetry') {
          <app-dashboard-tile-data-telemetry [recent]="recent" />
        }
        @case ('issues') {
          <app-dashboard-tile-data-offline [recent]="recent" />
        }
      }
    </div>
  </div>
} @placeholder {
  <i class="mdi mdi-spin-x2 mdi-loading"></i>
}
